module.exports = __webpack_public_path__ + "static/media/instagram-02.27b8f54a.jpg";